/**
 * @fileOverview
 * @author sergey
 */

define(['sandbox', 'AbstractAction'], function(sandbox, AbstractAction) {
  'use strict';

  return AbstractAction.extend({});
});